import Instance from '../../../Axios';

const RemoverProduto = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .delete(`/backend/produtos/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'DELETE_PRODUTO', payload: data });
    })
    .catch(({ err }) => console.log(err));
};

export default RemoverProduto;
